import misRutas from 'vue-routes-generator'
import LibretaDireccionesComponent from './App'
// Exportamos
export default {
	install: Vue => {
		misRutas.route('/main').child('libreta', {
			name: 'Gestión de libretas',
			component: LibretaDireccionesComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/libreta-direcciones/vue/index.js